export enum IdpFlowType {
  UNKNOWN = 'UNKNOWN',
  USER_REGISTRATION = 'USER_REGISTRATION',
  USER_REGISTRATION_ANONYMOUS = 'USER_REGISTRATION_ANONYMOUS',
  USER_INVITE = 'USER_INVITE',
  USER_REGISTRATION_GROUP_INVITE = 'USER_REGISTRATION_GROUP_INVITE',
  USER_EXTERNAL_REGISTRATION = 'USER_EXTERNAL_REGISTRATION',
}
